<template>
    <NavAndBody>
        <h1 class="page-title">유저 리스트</h1>
        <UserListFilter/>
        <UserList/>
    </NavAndBody>
</template>

<script>
    import UserList from '@/components/user/UserList';
    import NavAndBody from '@/components/layout/NavAndBody';
    import UserListFilter from '@/components/user/UserListFilter';

    export default {
        name: 'UserListView',
        components: {UserListFilter, NavAndBody, UserList},
    };
</script>

<style lang="scss" scoped>

</style>